import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs"
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import VulscanTableSection from "./VulscanTableSection";



const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Vulnerability Management",
        redirectTo: "/vulscan",
    }
]


function VulscanPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Vulnerability Management: Nmap')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <div className="network-scan-page-v2">
            <InfoBoxes />
            <VulscanTableSection />
        </div>
    )

}

export default withMainLayout(connect()(VulscanPage));
